import { DocumentsState } from '../../interfaces/DocumentsState';
import { Document } from '../../interfaces/Document';
import { DocumentSearchCriteria } from '../../interfaces/DocumentSearchCriteria';
import getCurrentPeriod from '../../utils/getCurrentPeriod';
import getDocumentsInSameGroup from '../../components/DocumentListResource/DocumentList/DocumentListGroup/GroupedContracts/GroupedContract/getDocumentsInSameGroup';

export const filterDocuments = (state: DocumentsState): DocumentsState => {
  const currentPeriod = getCurrentPeriod(state.groups);
  const allDocs = state.groups.flatMap((x) => x.documents);
  const groups = state.groups.map((g) => {
    let visibleDocs = g.documents;
    visibleDocs = filterByKeyword(state.searchCriteria, visibleDocs, allDocs);
    visibleDocs = filterByPeriod(state.searchCriteria, visibleDocs, currentPeriod);
    visibleDocs = filterByType(state.searchCriteria, visibleDocs);
    visibleDocs = filterByProduct(state.searchCriteria, visibleDocs);

    return ({
      ...g,
      documents: g.documents.map((d) => ({ ...d, visible: visibleDocs.indexOf(d) > -1 })),
    });
  });

  return {
    ...state, groups,
  };
};

function filterByKeyword(criteria: DocumentSearchCriteria, documents: Document[], allDocs: Document[]): Document[] {
  const normalize = (x: string) => x.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
  const match = (x: Document) => normalize(x.name).includes(normalize(criteria.keyword));
  if (criteria.keyword) {
    return documents.filter((d) => {
      if (d.grouped) {
        return match(d) || getDocumentsInSameGroup(d, allDocs).filter((x) => match(x)).length > 0;
      }

      return match(d);
    });
  }
  return documents;
}

function filterByPeriod(criteria: DocumentSearchCriteria, documents: Document[], currentPeriod: string): Document[] {
  if (criteria.period && criteria.period === 'CURRENT') {
    const years = currentPeriod.split('-');
    return documents.filter((d) => years.indexOf(d.year.toString()) > -1);
  }
  if (criteria.period && criteria.period !== 'SELECT_ALL') {
    return documents.filter((d) => d.year === +criteria.period);
  }
  return documents;
}

function filterByType(criteria: DocumentSearchCriteria, documents: Document[]): Document[] {
  if (criteria.type && criteria.type.length > 0) {
    return documents.filter((d) => criteria.type.indexOf(d.type.id) > -1);
  }
  return documents;
}

function filterByProduct(criteria: DocumentSearchCriteria, documents: Document[]): Document[] {
  if (criteria.product && criteria.product.length > 0) {
    return documents.filter((d) => criteria.product.indexOf(`${d.contract.contractNumber}-${d.contract.systemCode}`) > -1);
  }
  return documents;
}
